import KeyboardKeyCap from "./KeyboardKeyCap";
import "./TrainingShortcutsLegend.css";

const SHORTCUTS = [
  { key: "F", label: "mettre/retirer des favoris" },
  { key: "P", label: "mettre/retirer des prioritaires" },
  { key: "C", label: "afficher/masquer le mot" },
];

export default function TrainingShortcutsLegend() {
  return (
    <span className="compteurMots training-shortcuts-legend">
      {SHORTCUTS.map((shortcut) => (
        <span key={shortcut.key} className="training-shortcuts-legend__item">
          <KeyboardKeyCap aria-hidden="true">{shortcut.key}</KeyboardKeyCap>
          <span>{shortcut.label}</span>
        </span>
      ))}
    </span>
  );
}
